/* Edits the state whenever fileStructure event triggers */

export function fileFetchHasErrored(state = false, action) {
	switch (action.type) {
	case 'FILE_STRUCTURE_LOAD_FAILED':
		return action.hasErrored;
	default:
		return state;
	}
}
export function fileFetchIsLoading(state = false, action) {
	switch (action.type) {
	case 'FILE_STRUCTURE_ISLOADING':
		return action.isLoading;
	default:
		return state;
	}
}
export function fileStructure(state = [], action) {
	switch (action.type) {
	case 'FILE_STRUCTURE_LOADED':
		return action.files;
	default:
		return state;
	}
}
